import { DataGrid } from "@mui/x-data-grid";
import React from "react";
import editIcon from "../../../assets/images/Edit.svg";
import deleteIcon from "../../../assets/images/Delete.svg";
import { MuiDataGridStyle } from "../../../theme/App.theme";
import NoRecordsToDisplay from "../../../components/CommonReusableComponent/NoRecordsToDisplay/NoRecordsToDisplay";

const AreaMasterDataTable_V2 = ({
  Rows,
  GetRowDataOnClickOfAction,
  PageSizeOptions,
  RowsToDisplay,
}) => {
  const Columns = [
    {
      field: "action",
      headerName: "Action",
      headerAlign: "center",
      filterable: false,
      sortable: false,
      disableColumnMenu: true,
      minWidth: 90,
      maxWidth: 90,
      renderCell: (param) => (
        <div className="d-flex justify-content-center align-items-center h-100 gap-3">
          <img
            src={editIcon}
            className="cursor-pointer"
            alt={"Edit"}
            style={{ width: "20px", height: "20px" }}
            onClick={() => {
              GetRowDataOnClickOfAction("Update Area", param.row);
            }}
          />
          <img
            src={deleteIcon}
            className="cursor-pointer"
            alt={"Edit"}
            style={{ width: "20px", height: "20px" }}
            onClick={() => {
              GetRowDataOnClickOfAction("Delete Area", param.row);
            }}
          />
        </div>
      ),
    },
    {
      field: "name",
      headerName: "Area Name",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "departmentName",
      headerName: "Department Name",
      flex: 1,
      sortable: false,
      minWidth: 200,
    },
    {
      field: "branchName",
      headerName: "Branch Name",
      flex: 1,
      sortable: false,
      minWidth: 200,
    },
  ];

  return (
    <React.Fragment>
      <div className="w-100">
        <DataGrid
          columns={Columns}
          rows={Rows}
          slots={{
            noRowsOverlay: NoRecordsToDisplay,
          }}
          pageSizeOptions={PageSizeOptions || [5, 10, 15, 25, 50]}
          initialState={{
            density: "compact",
            pagination: {
              paginationModel: {
                pageSize: RowsToDisplay || 10,
              },
            },
          }}
          disableRowSelectionOnClick
          density="compact"
          className="custom-data-grid"
          sx={MuiDataGridStyle}
        />
      </div>
    </React.Fragment>
  );
};

export default AreaMasterDataTable_V2;
